// Browser tab titles: "Stores · Ground Team", so a manager with several console tabs open can tell them apart.

import { useEffect } from 'react';

export const APP_TITLE = 'Ground Team';

/** "Stores · Ground Team"; just "Ground Team" for an empty title. Whitespace is collapsed (names come from payloads). */
export function documentTitle(title: string | null | undefined): string {
  const t = (title ?? '').replace(/\s+/g, ' ').trim();
  return t === '' ? APP_TITLE : `${t} · ${APP_TITLE}`;
}

/**
 * Sets the tab title while the calling page is mounted and restores the previous one afterwards. Pass the store or
 * rep name on detail pages (null while it loads keeps the plain app title).
 */
export function useDocumentTitle(title: string | null | undefined): void {
  useEffect(() => {
    if (typeof document === 'undefined') return;
    const previous = document.title;
    document.title = documentTitle(title);
    return () => {
      document.title = previous;
    };
  }, [title]);
}
